import React from 'react';
import { Box, Stack } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';

interface DateRangePickerProps {
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  onStartDateChange: (date: Dayjs | null) => void;
  onEndDateChange: (date: Dayjs | null) => void;
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}) => {
  const today = dayjs(); // Get today's date
  const minDate = dayjs('2024-01-01'); // Minimum date: January 1st, 2024

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
        <DatePicker
          label="Start Date"
          value={startDate}
          onChange={onStartDateChange}
          // Start date cannot be before Jan 1, 2024, after end date (if set), or in the future
          minDate={minDate}
          maxDate={endDate && endDate.isBefore(today) ? endDate : today}
          format="DD/MM/YYYY"
          slotProps={{
            textField: {
              size: 'small',
              fullWidth: true,
              inputProps: { readOnly: true }, // Make the input read-only
            },
          }}
        />
        <DatePicker
          label="End Date"
          value={endDate}
          onChange={onEndDateChange}
          // End date cannot be before Jan 1, 2024, before start date (if set), or in the future
          minDate={startDate ? (startDate.isAfter(minDate) ? startDate : minDate) : minDate}
          maxDate={today}
          format="DD/MM/YYYY"
          slotProps={{
            textField: {
              size: 'small',
              fullWidth: true,
              inputProps: { readOnly: true }, // Make the input read-only
            },
          }}
        />
      </Stack>
    </LocalizationProvider>
  );
};

export default DateRangePicker;
